// Complimentary Akoya studs (replaces the BOGOS app). Keeps exactly one gift line in the cart while the
// non-gift merchandise, before any discount, reaches the threshold, and none below it. Discounts applied
// later at checkout do not remove it. Config: layout/theme.liquid; amounts: snippets/akoya-threshold.liquid.
(() => {
  const config = JSON.parse(document.getElementById('GiftSyncConfig')?.textContent || 'null');
  if (!config) return;
  // ponytail: a currency missing from the table compares against USD 1,000 at the market rate.
  const threshold = config.threshold ?? Math.round(100000 * Number(window.Shopify?.currency?.rate || 1));
  const isGift = (item) => item.variant_id === config.variant;
  // the BOGOS clone left in carts from before the switch to our own gift product
  const isOldGift = (item) => !isGift(item) && item.handle?.endsWith('-sca_clone_freegift');

  const paint = (html, target, selector) => {
    const source = html && new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (source && target) target.innerHTML = source.innerHTML;
  };

  async function run() {
    const cart = await (await fetch(`${routes.cart_url}.js`)).json();
    const gifts = cart.items.filter(isGift);
    const oldGifts = cart.items.filter(isOldGift);
    const subtotal = cart.items.reduce((sum, item) => (isGift(item) ? sum : sum + item.original_line_price), 0);
    const want = subtotal >= threshold ? 1 : 0;
    if (gifts.length === want && (!want || gifts[0].quantity === 1) && !oldGifts.length) return;

    const updates = {};
    oldGifts.forEach((item) => (updates[item.key] = 0));
    gifts.forEach((item, i) => (updates[item.key] = i === 0 ? want : 0));
    if (want && !gifts.length) updates[config.variant] = 1;
    // Until the lines re-render, their indices are stale (a tap on remove could hit the wrong line) and
    // checkout would race the change: freeze both. publish resolves after the subscribers' refetches.
    const frozen = [...document.querySelectorAll('#main-cart-items, #CartDrawer-CartItems')];
    const buttons = [...document.querySelectorAll('[name="checkout"]:not(:disabled)')];
    frozen.forEach((el) => el.classList.add('cart__items--disabled'));
    buttons.forEach((button) => (button.disabled = true));
    try {
      // The drawer and cart items refresh themselves on cartUpdate; the header bag and the cart page
      // footer (ledger, progress line) do not, so they ride along on this request.
      const footer = document.getElementById('main-cart-footer');
      const sections = ['cart-icon-bubble', footer?.dataset.id].filter(Boolean);
      const response = await fetch(routes.cart_update_url, {
        ...fetchConfig(),
        body: JSON.stringify({ updates, sections, sections_url: window.location.pathname }),
      });
      const state = await response.json();
      if (!response.ok) return console.warn('gift-sync:', state.description || state.message);

      const bubble = document.getElementById('cart-icon-bubble');
      paint(state.sections?.['cart-icon-bubble'], bubble?.querySelector('.shopify-section') || bubble, '.shopify-section');
      if (footer) paint(state.sections?.[footer.dataset.id], footer.querySelector('.js-contents'), '.js-contents');
      if (footer) paint(state.sections?.[footer.dataset.id], footer.querySelector('.cart__service'), '.cart__service');
      // the drawer heading count sits outside what the drawer refetch swaps; like snippets/bag-count.liquid it leaves out $0 lines
      const bagCount = state.items.reduce((sum, item) => (item.original_line_price ? sum + item.quantity : sum), 0);
      document.querySelectorAll('.cart-drawer__count').forEach((el) => (el.textContent = bagCount));
      document
        .querySelectorAll('cart-drawer, cart-items, #main-cart-footer')
        .forEach((el) => el.classList.toggle('is-empty', state.item_count === 0));
      await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-sync', cartData: state });
    } finally {
      frozen.forEach((el) => el.classList.remove('cart__items--disabled'));
      buttons.forEach((button) => (button.disabled = false));
    }
  }

  // One run at a time; a call during a run queues exactly one more after it.
  let running = null;
  let again = false;
  function sync() {
    if (running) return void (again = true);
    running = run()
      .catch((e) => console.warn('gift-sync:', e))
      .finally(() => {
        running = null;
        if (again) {
          again = false;
          sync();
        }
      });
  }

  // Never on our own publish, so a fix cannot trigger another fix.
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event?.source !== 'gift-sync') sync();
  });
  // Covers /cart/<variant>:<qty> permalinks and full page loads with a filled cart.
  if (config.count > 0) sync();
})();
